import { fetchJson } from "../lib/api";

export type DeliveryAddressFacet = {
  delivery_address_key: string;
  delivery_address_display: string | null;
  is_warehouse: boolean | null;
  line_count: number | null;
  total_spend: string | number | null;
  document_count: number | null;
};

export type DeliveryAddressListResponse = {
  limit: number;
  items: DeliveryAddressFacet[];
  /** Addresses used on this cost center's documents, most positions first (#548). */
  suggested?: DeliveryAddressFacet[];
};

export async function fetchDeliveryAddresses(
  options: { q?: string; limit?: number; costCenter?: { type: string; key: string } | null } = {},
): Promise<DeliveryAddressListResponse> {
  const params = new URLSearchParams();
  if (options.q) params.set("q", options.q);
  if (options.limit != null) params.set("limit", String(options.limit));
  if (options.costCenter) {
    params.set("cost_center_type", options.costCenter.type);
    params.set("cost_center_key", options.costCenter.key);
  }
  const qs = params.toString();
  return fetchJson<DeliveryAddressListResponse>(
    `/api/delivery-addresses${qs ? `?${qs}` : ""}`,
  );
}
